import { render, staticRenderFns } from "./IACode.vue?vue&type=template&id=cc262e22&"
import script from "./IACode.vue?vue&type=script&lang=js&"
export * from "./IACode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports